// src/redux/settingsPages/language/languageSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchAvailableLanguages, fetchUserLanguage, updateUserLanguage } from './languageActions';

const initialState = {
  available: [],              // [{ code, name, nativeName }]
  current: 'en',              // language code
  direction: 'ltr',           // 'ltr' | 'rtl'
  loading: false,
  error: null,
  updating: false,
  updateError: null,
};

const slice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    // Optional immediate UI switch without hitting server
    setLanguageLocal(state, action) {
      const code = action.payload;
      state.current = code;
      state.direction = /^(ar|he|fa|ur)(-|$)/i.test(code) ? 'rtl' : 'ltr';
    },
    clearLanguageError(state) {
      state.error = null;
      state.updateError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // available
      .addCase(fetchAvailableLanguages.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(fetchAvailableLanguages.fulfilled, (s, a) => {
        s.loading = false;
        s.available = Array.isArray(a.payload) ? a.payload : [];
      })
      .addCase(fetchAvailableLanguages.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload || 'Failed to load languages';
      })

      // current
      .addCase(fetchUserLanguage.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(fetchUserLanguage.fulfilled, (s, a) => {
        s.loading = false;
        s.current = a.payload?.code ?? 'en';
        s.direction = a.payload?.direction ?? 'ltr';
      })
      .addCase(fetchUserLanguage.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload || 'Failed to load current language';
      })

      // update
      .addCase(updateUserLanguage.pending, (s) => { s.updating = true; s.updateError = null; })
      .addCase(updateUserLanguage.fulfilled, (s, a) => {
        s.updating = false;
        s.current = a.payload?.code ?? s.current;
        s.direction = a.payload?.direction ?? s.direction;
      })
      .addCase(updateUserLanguage.rejected, (s, a) => {
        s.updating = false;
        s.updateError = a.payload || 'Failed to update language';
      });
  },
});

export const { setLanguageLocal, clearLanguageError } = slice.actions;
export default slice.reducer;
